'use strict';
import Vue from 'vue'

Vue.filter("formatMoney", (val) => {
	if (!val) return '0.00'
	val = val.toFixed(2)
	const intPart = Math.trunc(val)
	const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
	let floatPart = '.00'
	const newArr = val.toString().split('.')
	if (newArr.length === 2) {
	  floatPart = newArr[1].toString()
	  return intPartFormat + '.' + floatPart
	}
	return intPartFormat + floatPart
})
